import { render, staticRenderFns } from "./ServiceDialog.vue?vue&type=template&id=15318fa4&scoped=true"
import script from "./ServiceDialog.vue?vue&type=script&lang=js"
export * from "./ServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./ServiceDialog.vue?vue&type=style&index=0&id=15318fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15318fa4",
  null
  
)

export default component.exports